import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ajaxDeliveryNotes from "../../util/remote/ajaxDeliveryNotes";
import ajaxSupplierInvoices from "../../util/remote/ajaxSupplierInvoices"; // <-- new API for invoices
const CreateSupplierInvoice = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Form fields
  const [delID, setdelID] = useState("");
  const [invoice_no, setInvoiceNo] = useState("");
  const [amount, setAmount] = useState("");
  const [dateCreated, setDateCreated] = useState(() => {
    const today = new Date();
    return today.toLocaleDateString("en-CA"); // YYYY-MM-DD local
  });

  // Delivery notes (selectables)
  const [delivery_selectables, setdelivery_selectables] = useState([]);
  const fetchdelivery_selectables_mini_data = async () => {
    const server_response =
      await ajaxDeliveryNotes.fetchDeliveryNotes_selectables({});
    if (server_response.status === "OK") {
      setdelivery_selectables(
        Array.isArray(server_response.details) ? server_response.details : []
      );
    } else {
      setdelivery_selectables([]);
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchdelivery_selectables_mini_data();
  }, []);
  // Validate required fields
  const allRowsFilled = () => {
    return delID && invoice_no.trim() !== "" && amount.trim() !== "";
  };
  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please fill in all required fields");
      return;
    }
    const data = {
      DeliveryID: Number(delID),
      invoice_no: invoice_no,
      date_created: dateCreated,
      amount: amount,
      created_by: userId,
    };
    setLoading(true);
    const response = await ajaxSupplierInvoices.createSupplierInvoice(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setdelID("");
    setInvoiceNo("");
    setAmount("");
    setDateCreated(new Date().toISOString().split("T")[0]);
  };
  return (
    <AppContainer title="Create Supplier Invoice">
      <div className="container-fluid">
        <Toaster />
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/supplier_invoices/view")}
            >
              View Supplier Invoices
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Create Supplier Invoice</h6>
                <form onSubmit={handleAdd}>
                  <div className="row">
                    {/* Left column */}
                    <div className="col-md-6">
                      <div className="col-md-12 mb-3">
                        <label>
                          Select Delivery Note
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          onChange={(selected) => setdelID(selected?.delID)}
                          getOptionLabel={(option) => (
                            <span>
                              <span style={{ color: "red" }}>
                                Delivery_reff
                              </span>
                              ({option.delievery_reff_no})
                              <span style={{ color: "blue" }}>Order_reff</span>(
                              {option.internal_order_reff})
                            </span>
                          )}
                          getOptionValue={(option) => option.delID}
                          isSearchable
                          options={
                            Array.isArray(delivery_selectables)
                              ? delivery_selectables
                              : []
                          }
                          value={
                            Array.isArray(delivery_selectables)
                              ? delivery_selectables.find(
                                  (value) => value.delID === delID
                                ) || null
                              : null
                          }
                          placeholder="Select Delivery Note"
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label>
                          Invoice No <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          value={invoice_no}
                          onChange={(e) => setInvoiceNo(e.target.value)}
                          className="form-control"
                          placeholder="Invoice Number"
                          required
                        />
                      </div>
                    </div>
                    {/* Right column */}
                    <div className="col-md-6">
                      <div className="form-group col-md-12 mb-3">
                        <label>
                          Amount <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <label>
                          Date Created <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          value={dateCreated}
                          onChange={(e) => setDateCreated(e.target.value)}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center col-lg-12">
                    <button
                      type="submit"
                      className="btn btn-success col-lg-12"
                      disabled={!allRowsFilled() || loading}
                    >
                      {loading ? <Loader /> : "Submit Supplier Invoice"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default CreateSupplierInvoice;
